(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', (event) => {
    if (event.target.id !== 'CartDrawer-Form') return;

    const submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout' || submitter.hasAttribute('disabled')) return;

    submitter.classList.add('loading');
    submitter.querySelector('.loading__spinner')?.classList.remove('hidden');
  });
  } catch(e) { console.error(e); }
})();

})();
